import { render, staticRenderFns } from "./SelectorExtra.vue?vue&type=template&id=e8dc629a&scoped=true&"
import script from "./SelectorExtra.vue?vue&type=script&lang=js&"
export * from "./SelectorExtra.vue?vue&type=script&lang=js&"
import style0 from "./SelectorExtra.vue?vue&type=style&index=0&id=e8dc629a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dc629a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTab,
  VTabs,
})
